<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Design System Components
	// Types
	import type { Device } from 'src/types/Device.ts';
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import { real_id } from 'src/helpers/interface_helpers';
	import DeviceViewStateWrapper from '../DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import {
		canShowGen1LabelList,
		createGen1CombinedLabelList,
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';

	export let device: Device;

	$: deviceConfig = devices_config?.[device?.type];

	let timerLabels: Record<string, any> = {};

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses, device);

	$: combinedLabelList = createGen1CombinedLabelList(timerLabels, labelList);
</script>

<DeviceViewStateWrapper {device}>
	<div class="label-list-wrapper mb-s" slot="staticTop">
		{#if canShowGen1LabelList(device, status)}
			<DeviceLabelList labelList={combinedLabelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		<InputsReaderVisualizerV2 {device} {status} {settings} isInCard={false} />
	</div>
</DeviceViewStateWrapper>
